import {IEmployment} from "@/dto/payroll/IEmployment";
import CompanyDTO from "@/dto/company/CompanyDTO";
import AddressDTO from "@/dto/AddressDTO";

export class CreateProjectPayload {
    title: string | null = null
    companyId: number | null = null
}

export class UpdateProjectPayload {
    id: number | null = null
    title: string | null = null
    employmentsId: number[] = []
    managersId: number[] = []
}

export class ProjectDTO {
    id!: number
    title!: string
    company!: CompanyDTO
    address?: AddressDTO
    employments: IEmployment[] = []
    managers: IEmployment[] = []
    manager!: boolean

    constructor(init? : Partial<ProjectDTO>) {
        Object.assign(this, init)
    }
}

export class ProjectDTOWithHolder extends ProjectDTO{

    public holder!: IEmployment;
    public selected = false

    constructor(employment: IEmployment, init? : Partial<ProjectDTO> ) {
        super(init);
        this.holder = employment;
    }
}